import pieBlue from '@images/home/pie-blue.png'
import Component from '@glimmer/component'
import { t } from 'ember-intl'
import { HomeTile } from 'teacher-ui-client/components/home/tile'
import { UiButtonLinkTo } from 'teacher-ui-client/components/ui-button/link-to'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { posthogEvent } from 'teacher-ui-client/modifiers/posthog'

interface Signature {
  Args: {
    reportingDashboardModels: unknown[]
  }
}

export class ReportsReading extends Component<Signature> {
  get pieBluePng() {
    return pieBlue
  }
  <template>
    <HomeTile @themeKey={{themeKey "reading"}} @title={{t "pages.home.panels.reports.title"}}>
      <div class="space-y-3 bg-white p-3">
        <div class="flex h-28 items-start">
          <img class="mr-6" src={{this.pieBluePng}} alt={{t "pages.home.panels.reports.imageAlt"}} />
          <p class="mb-3">{{t "pages.home.panels.reports.description"}}</p>
        </div>
        <div class="text-center">
          <UiButtonLinkTo
            @route="reporting.ui-scope.re.dashboard"
            @models={{@reportingDashboardModels}}
            @appearance={{ButtonAppearance.regular}}
            {{posthogEvent "Reporting" product="reading" page="dashboard"}}
          >
            {{t "products.re"}}
            {{t "pages.home.panels.reports.buttonLabel"}}
          </UiButtonLinkTo>
        </div>
        <div class="text-center">
          <UiButtonLinkTo
            @route="reporting.ui-scope.rex.dashboard"
            @models={{@reportingDashboardModels}}
            @appearance={{ButtonAppearance.regular}}
            {{posthogEvent "Reporting" product="REX" page="dashboard"}}
          >
            {{t "products.rex"}}
            {{t "pages.home.panels.reports.buttonLabel"}}
          </UiButtonLinkTo>
        </div>
        <div class="text-center">
          <UiButtonLinkTo
            @route="reporting.ui-scope.fast-phonics.dashboard"
            @models={{@reportingDashboardModels}}
            @appearance={{ButtonAppearance.regular}}
            {{posthogEvent "Reporting" product="FP" page="dashboard"}}
          >
            {{t "products.fp"}}
            {{t "pages.home.panels.reports.buttonLabel"}}
          </UiButtonLinkTo>
        </div>
      </div>
    </HomeTile>
  </template>
}

export default ReportsReading
